import axios from "@main/axios";
import {isValidTel, isValidMail, loadCaptchaToken} from "@main/helpers/is-valid-field";
import {TabsSlider} from "@main/components/sliders/tabs";
import {Tabs} from "@main/components/tabs";
import {getCookie, setCookie} from "@main/utils/cookie";
import {ToggleScroll} from "@main/components/toggle-scroll";
export default class FormBasic {
    formSection;
    documentHtmlLang = document.documentElement.getAttribute("lang");

    constructor(el) {
        this.el = el;
        this.url = this.el.dataset.url;
        this.requiredNodes = this.el.querySelectorAll("[required]");
        this.inputs = this.el.querySelectorAll("input");
        this.textarea = this.el.querySelectorAll("textarea");

        this.telField = this.el.querySelector(".js-tel-input");
        this.telFieldParent = this.telField?.parentElement;
        this.telErrorTextNode = this.telFieldParent?.querySelector(".error");

        this.mailField = this.el.querySelector(".js-mail-input");
        this.mailFieldParent = this.mailField?.parentElement;
        this.mailErrorTextNode = this.mailFieldParent?.querySelector(".error");
        this.nameFields = this.el.querySelectorAll(".js-name-input");
        this.submitBtn = this.el.querySelector(".js-form-submit-btn");
        this.documentEl = document.body;
        this.modalAskQuestion = document.querySelector(".js-modal-ask-question");
        this.modalQuestionnaire = document.querySelector(".js-modal-questionnaire");
        this.modalProftest = document.querySelector(".js-modal-proftest");
        this.btnSubmit = this.modalAskQuestion?.querySelector(".js-form-submit-btn");
        this.modalResultProftest = document.querySelector(".js-modal-result-proftest");
        this.yandex = window.config?.yandex.key;
        this.isLeaveRequestForm = this.el.classList.contains("js-form-leave-request");
        this.init();
        loadCaptchaToken(this.el, "input[name='captcha_token']");
    }

    init() {
        this.el.addEventListener("submit", e => {
            e.preventDefault();
            this.sendData();
        });


        if (this.el.closest("section[data-bound-form]")) {
            const sectionForm = this.el.closest("section[data-bound-form]");

            sectionForm.addEventListener("click", e => {
                if (e.target.classList.contains("js-form-submit-btn")) {
                    this.onClickBtnSubmit(e);
                }
            })
        } else {
            this.submitBtn.addEventListener("click", e => {
                this.onClickBtnSubmit(e);
            });
        }

        this.requiredNodes.forEach(node => {
            node.addEventListener("focus", () => {
                const parent = node.parentElement;
                parent.classList.remove("input-error");
            });
        });

        this.telField?.addEventListener("focus", () => {
            this.telFieldParent.classList.remove("input-error");
        });

        this.mailField?.addEventListener("focus", () => {
            this.mailFieldParent.classList.remove("input-error");
        });

        if (this.el.classList.contains("js-enter-site")) {
            this.inputs.forEach(input => {
                input.addEventListener("input", () => {
                    this.el.classList.remove("error");
                })
            })
        }

        this.nameFields?.forEach(nameInput => {
            nameInput.addEventListener("input", () => {
                this.preventEnteringNumbersInFieldName(nameInput);
            });

            nameInput.addEventListener("paste", () => {
                this.preventEnteringNumbersInFieldName(nameInput);
            });
        }) 
    }

    onClickBtnSubmit(e) {
        e.preventDefault();

        let isValid = true;

        this.requiredNodes.forEach(node => {
            if ((node.type === "checkbox" && !node.checked) || !node.value.trim().length) {
                const parent = node.parentElement;
                const errorText = parent.querySelector(".error");
                errorText.textContent =
                    this.documentHtmlLang === "en" ? "Required field" : "Обязательное поле";
                parent.classList.add("input-error");
                isValid = false;
            }
        });

        isValid = this.checkCountryPhoneFiled(isValid);

        if (
            this.telField &&
            !isValidTel(this.telField) &&
            (this.telField.value.length !== 0 || this.telField.required)
        ) {
            this.telFieldParent.classList.add("input-error");
            this.telErrorTextNode.textContent =
                this.documentHtmlLang === "en" ?
                    "Phone number is not in the correct format" :
                    "Номер телефона имеет неверный формат";
            isValid = false;
        }

        if (
            this.mailField &&
            this.mailField.value.length !== 0 &&
            !isValidMail(this.mailField)
        ) {
            this.mailFieldParent.classList.add("input-error");
            this.mailErrorTextNode.textContent = this.documentHtmlLang === "en" ?
                "Incorrect email" :
                "Некорректный email";
            isValid = false;
        }

        if (isValid) {
            this.sendData();
            this.formSection = e.target.closest("section");
        }
    }

    checkCountryPhoneFiled(isValid) {
        if (!this.telCountryField) {
            this.telCountryField = this.el.querySelector(".js-tel-input-country-real");
            if (this.telCountryField) {
                this.telCountryFieldParent = this.telCountryField.closest(".js-tel-input-country-wrap");
                this.telCountryErrorTextNode = this.telCountryFieldParent.querySelector(".error");
                this.telCountryField.addEventListener("focus", () => {
                    this.telCountryFieldParent.classList.remove("input-error");
                });
            }
        }
        if (this.telCountryField) {
            if (this.telCountryField.required && !this.telCountryField.value) {
                this.telCountryErrorTextNode.textContent = this.documentHtmlLang === "en" ? "Required field" : "Обязательное поле";
                this.telCountryFieldParent.classList.add("input-error");
                isValid = false;
            } else if (this.telCountryField.value && !this.telCountryField.inputmask.isValid()) {
                this.telCountryErrorTextNode.textContent = this.documentHtmlLang === "en" ?
                    "Phone number is not in the correct format" :
                    "Номер телефона имеет неверный формат";
                this.telCountryFieldParent.classList.add("input-error");
                isValid = false;
            }
        }
        return isValid;
    }

    showModal = (modalType, title, subtitle, link = undefined) => {
        const modal = document.querySelector(
            `.js-modal[data-modal="${modalType}"]`
        );
        const titleNode = modal.querySelector(".js-modal-title");
        const subtitleNode = modal.querySelector(".js-modal-subtitle");
        const linkNode = modal.querySelector(".js-modal-link");
        const tryAgainBtn = modal.querySelector(".js-modal-try-again");

        if (titleNode && title) {
            titleNode.textContent = title;
        }

        if (subtitleNode && subtitle) {
            subtitleNode.textContent = subtitle;
        }

        if (linkNode && link) {
            linkNode.setAttribute("href", link);
        }

        if (tryAgainBtn) {
            tryAgainBtn.addEventListener("click", this.sendData);
        }

        modal.classList.add("shown");
        ToggleScroll.disable(modal);
        this.formSection?.scrollIntoView({block: "center", inline: "center"});
        this.submitBtn.removeAttribute("disabled");
    };

    /**
     * Если форма в модале, то после отправки данных, перед выводом
     * модала об успешной отправке, модал с формой закрываем.
     *
     * @param {Response} response Ответ, полученный при отправке данных формы.
     * @returns {void}
     */
    closeModalOnSendData(response) {
        const modals = document.querySelectorAll(".js-modal");
        modals.forEach(modal => {
            if (modal?.classList.contains("shown")) {
                modal.classList.remove("shown");

                const title = response.data?.message
                    ? response.data.message
                    : "Все прошло отлично";

                this.showModal("success", title);
            }
        })
    }
    
    /**
     * Запрет ввода чисел в поле имени.
     *
     * @param {HTMLDivElement} field Контейнер поля вода.
     * @returns {void}
     */
    preventEnteringNumbersInFieldName(field) {
        field.value = field.value.replace(/[+$№^*)@:, .'`";_=<>%#~&!\\(?{}[\]/|\d]/g, "");
    }

    sendData = async () => {
        const calculator = this.el.closest(".js-сalculator");
        if (calculator) {
            if (!getCookie(calculator.dataset.cookie)) {
                return;
            }
        }
        const data = new FormData(this.el);
        this.submitBtn.setAttribute("disabled", "disabled");

        try {
            const response = await axios({
                url: this.url,
                data,
                method: "POST"
            });

            if (response?.data?.success) {
                this.inputs.forEach(input => {
                    if (!input.closest(".js-calculator-card") && !input.closest(".js-question-item")) {
                        input.value = "";
                    }
                    input.parentElement.classList.remove("filled");
                });
                this.textarea.forEach(textarea => {
                    textarea.value = "";
                    textarea.parentElement.classList.remove("filled");
                });

                if (response.data?.data?.redirectUrl) {
                    window.location.href = response.data.data.redirectUrl;
                }

                if (this.modalAskQuestion?.classList.contains("shown")) {
                    this.btnSubmit.setAttribute("disabled", "disabled");
                    this.modalAskQuestion.classList.remove("shown");

                    const title = response.data?.message.title
                        ? response.data.message.title
                        : "Все прошло отлично";

                    const subtitle = response.data?.message.subtitle
                        ? response.data.message.subtitle
                        : "";

                    this.showModal("success", title, subtitle);
                    if (typeof ym !== "undefined") {
                        ym(this.yandex, "reachGoal", "question_send"); // eslint-disable-line
                    }
                } else if (this.modalQuestionnaire?.classList.contains("shown")) {
                    this.modalQuestionnaire.classList.remove("shown");

                    const title = response.data?.message?.title
                        ? response.data?.message?.title
                        : "Все прошло отлично";

                    const subtitle = response.data?.message?.subtitle
                        ? response.data?.message?.subtitle
                        : "";

                    this.showModal("success", title, subtitle);
                    if (typeof ym !== "undefined") {
                        ym(this.yandex, "reachGoal", "application_work"); // eslint-disable-line
                    }
                } else if (this.modalProftest?.classList.contains("shown")) {
                    this.modalProftest.classList.remove("shown");
                    const title = response.data?.message?.title
                        ? response.data?.message?.title
                        : "Все отлично";

                    const subtitle = response.data?.message?.subtitle
                        ? response.data?.message?.subtitle
                        : "";

                    const direction = response.data?.data?.direction;
                    const lead = response.data?.data?.lead;
                    const resultProftestForm = this.documentEl.querySelector(".js-result-proftest-form");
                    const directionInput = resultProftestForm.querySelector("input[name='direction']");
                    const leadInput = resultProftestForm.querySelector("input[name='lead']");
                    if (directionInput) {
                        directionInput.value = direction;
                    }
                    if (leadInput) {
                        leadInput.value = lead;
                    }
                    this.showModal("result-proftest", title, subtitle);
                } else if (this.modalResultProftest?.classList.contains("shown")) {
                    this.modalResultProftest.classList.remove("shown");
                    this.showModal("proftest-success");
                } else if (calculator) {
                    const btnSubmit = calculator.querySelector(".js-form-submit-btn");
                    const program = response.data.data;

                    calculator.insertAdjacentHTML("afterend", program);
                    const slider = calculator.nextElementSibling.getElementsByClassName("js-tabs-slider");
                    const tabs = calculator.nextElementSibling.getElementsByClassName("js-tabs");

                    if (slider[0] && tabs[0]) {
                        new TabsSlider(slider[0]);
                        new Tabs(tabs[0]);
                    }

                    btnSubmit.setAttribute("disabled", "disabled");
                } else {
                    if (this.isLeaveRequestForm) {
                        this.el.classList.add("success");
                        return;
                    }
                    
                    if (this.el.closest(".subscribe__form")) {
                        if (typeof ym !== "undefined") {
                            ym(this.yandex, "reachGoal", "news_send"); // eslint-disable-line
                        }
                    }

                    if (this.el.closest(".form-questionnaire.js-recruitment-form")) {
                        if (typeof ym !== "undefined") {
                            ym(this.yandex, "reachGoal", "application_specialist"); // eslint-disable-line
                        }
                    } else if (this.el.closest(".form-questionnaire")) {
                        if (typeof ym !== "undefined") {
                            ym(this.yandex, "reachGoal", "application_training"); // eslint-disable-line
                        }
                    }

                    if (this.el.classList.contains("js-calculator-form-request")) {
                        setCookie(this.el.dataset.cookie, "accept");
                        document.querySelector(".js-form-submit-сalculator").click();
                        ToggleScroll.enable();
                    } else {
                        const title = response.data?.message
                            ? response.data.message
                            : "Все прошло отлично";
                        this.showModal("success", title);
                    }
                    this.closeModalOnSendData(response);
                }

                if (this.el.classList.contains("js-form-international")) {
                    this.el.querySelector(".js-add-language").removeAttribute("disabled");
                    const selectBlocks = this.el.querySelectorAll(".js-select-block");
                    const radioButtons = this.el.querySelectorAll("input[type='radio']");
                    const detailsBlocks = this.el.querySelectorAll(".js-question-item");

                    selectBlocks.forEach((block, i) => {
                        const select = block.querySelector(".js-international-select");
                        const selectWrapper = select.closest(".choices__inner");
                        const selectFieldContainer = select.closest(".js-select-wrap");
                        const selectPlaceholder = selectFieldContainer.dataset.placeholder;

                        selectFieldContainer.classList.remove("filled");
                        select.value = "";

                        const selectLabel = selectWrapper.querySelector(".choices__item--selectable");
                        selectLabel.innerHTML = selectPlaceholder;

                        if(i > 0) {
                            block.classList.add("hidden");
                        }
                    })

                    radioButtons.forEach(radio => radio.checked = false);

                    detailsBlocks.forEach(block => {
                        if(block.classList.contains("input-is-visible")) {
                            block.classList.remove("input-is-visible");
                        }
                    })
                }
            }
            if (!response?.data?.success) {
                const title = response.data?.message
                    ? response.data.message
                    : "Что-то пошло не так";

                if (this.el.classList.contains("js-enter-site")) {
                    const elementError = this.el.querySelector(".js-enter-site-error");
                    elementError.innerHTML = title;
                    this.el.classList.add("error");
                    this.el.querySelector("button[type='submit']").removeAttribute("disabled");
                    return;
                }

                if (this.isLeaveRequestForm) {
                    const messageElem = this.el.querySelector(".js-ajax-form-message")
                    this.el.classList.add("error");
                    messageElem.innerHTML = title;
                    return;
                }

                this.showModal("error", title);
            }
        } catch (error) {
            console.log(error);
            this.showModal("error");
        }
    };
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-form-basic")
        .forEach(el => new FormBasic(el));
});
